import Addon from "~/types/cms/Addon";
import CMSProduct from "~/types/cms/CMSProduct";
import Image from "~/types/shopify/Image";
import LineItem from "~/types/shopify/LineItem";
import Money from "~/types/shopify/Money";
import ShopifyProduct from "~/types/shopify/ShopifyProduct";
import ShopifyVariant from "~/types/shopify/ShopifyVariant";

export default {
  methods: {
    mapShopifyProducts(response: any): ShopifyProduct[] {
      if (!response?.products?.edges) return [];

      const products: ShopifyProduct[] = response.products.edges.map(
        (edge: { node: any }) => new ShopifyProduct(edge.node)
      );
      return products;
    },
    mapCMSProducts(response: any, collectionType: string): CMSProduct[] {
      if (!response?.data?.data[collectionType]) return [];

      const products: CMSProduct[] = response.data.data[collectionType].map(
        (data: any) => new CMSProduct(data)
      );
      return products;
    },
    mapCMSAddons(response: any): Addon[] {
      if (!response?.data?.data) return [];

      const addons: Addon[] = response.data.data.addons.map(
        (data: any) => new Addon(data)
      );
      return addons;
    },
    //Order: Luxe -> Bright -> Neutral -> Pastel -> Basic
    sortProductsByStyle(list: any[]) {
      // update the productlines order
      const productLineOrder = ["luxe", "signature-bright", "signature-neutral", "signature-pastel", "signature", "basic-signature", "basic"];

      const tagOrderForSignature = ["Style:Bright", "Style:Neutral", "Style:Pastel"];

      list.sort((a, b) => {
        const aProductLineIndex = productLineOrder.indexOf(a.productLine ?? "");
        const bProductLineIndex = productLineOrder.indexOf(b.productLine ?? "");

        if (aProductLineIndex === -1 || bProductLineIndex === -1) {
          return a.title.localeCompare(b.title);
        } else if (a.productLine === "signature" && b.productLine === "signature") {
          const aTagIndex = tagOrderForSignature.findIndex((tag) => a.tags.includes(tag));
          const bTagIndex = tagOrderForSignature.findIndex((tag) => b.tags.includes(tag));

          if (aTagIndex === -1 || bTagIndex === -1) {
            return a.title.localeCompare(b.title);
          }

          return aTagIndex - bTagIndex;
        }

        return aProductLineIndex - bProductLineIndex;
      });

      return list;
    },
    splitAndSort(items: any) {
      const sortedItems = items.sort((a: { price: number }, b: { price: number }) =>
        a.price < b.price ? 1 : a.price > b.price ? -1 : 0
      );

      const surpriseIndex = sortedItems.findIndex((item: { title: string }) => item.title.includes("Surprise"));
      const surprise = surpriseIndex !== -1 ? sortedItems.splice(surpriseIndex) : [];

      return [...sortedItems, ...surprise];
    },
    addLineItem(item: any, productType: string): LineItem {
      let lineItem: LineItem = new LineItem();
      let variant: ShopifyVariant = new ShopifyVariant();
      variant.title = item.object.title;
      variant.id = item.id;
      variant.description = item.object.description;

      let price: Money = new Money();
      price.amount = item.object.price;
      variant.price = price;

      let image: Image = new Image();
      image.imageURL = item.src;
      variant.image = image;

      lineItem.title = item.object.title;
      lineItem.id = item.id;
      lineItem.variant = variant;
      lineItem.productType = productType;
      //lineItem.quantity = this.getQuantity(lineItem.title);
      lineItem.variant = variant;
      return lineItem;
    },
    sortProductsByListType(list: any[]) {
      // update the product  list types
      const listTypesOrder = ["bouquet", "dried-bouquet", "centrepiece"];

      const orderedArray = list.sort((a, b) => {
        const indexA = a.tags.findIndex((tag: string) => listTypesOrder.includes(tag));
        const indexB = b.tags.findIndex((tag: string) => listTypesOrder.includes(tag));

        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }
        if (indexA !== -1) {
          return -1;
        }
        if (indexB !== -1) {
          return 1;
        }
        return 0;
      });

      return orderedArray;
    }
  },
};
